import React, {Component} from 'react'
import {connect} from "react-redux";
import {Grid} from "react-bootstrap";
import PageTitle from "../../../../common/page-title";
import '../../../products/common/styles.css'
import ArrowButton from "../../../../common/button-arrow";
import {Link} from "react-router-dom";
import PricePromotionsSearchPanel from './price-promotions-search-panel';
import {getPromotions} from '../../../../../actions/promotions'
import withInputChange from "../../../../withInputChange";
import PromotionsList from "./price-promotions-list";

class Promotions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayFromDate: '',
      displayToDate: '',
      product: '',
      group: ''
    }
  }

  componentDidMount() {
    this.onApply();
  }

  onApply = () => {
    const {displayFromDate, displayToDate, product, group} = this.props.fields;
    this.props.dispatch(getPromotions(displayFromDate, displayToDate, product, group));
  };

  render() {
    const {
      productList, groupList, handleChange, handleClearFilters,
      promotions, fetching, fetched, fields
    } = this.props;

    return (
      <Grid bsClass="container" fluid className="products accordion">
        <PageTitle>Price Promotions</PageTitle>
        <Link to="/admin/promotions/new">
          <div className="mg-bottom-20">
            <ArrowButton
              color="red"
              className="add-promotion"
              submit={false}
              arrow={false}
              permissions={{
                action: 'new',
                subjectClass: 'Promotion'
              }}
            >
              New Price Promotion
            </ArrowButton>
          </div>
        </Link>
        <PricePromotionsSearchPanel
          productValue={fields.product}
          onProductChange={handleChange('product')}
          productList={productList}
          groupValue={fields.group}
          onGroupChange={handleChange('group')}
          groupList={groupList}
          displayFromDateValue={fields.displayFromDate}
          handleDisplayFromDateChange={handleChange('displayFromDate')}
          displayToDateValue={fields.displayToDate}
          handleDisplayToDateChange={handleChange('displayToDate')}
          onApply={this.onApply}
          onClearFilters={handleClearFilters(this.onApply)}
        />
        <PromotionsList
          promotions={promotions}
          fetching={fetching}
          fetched={fetched}
        />
      </Grid>
    )
  }
}

const mapStateToProps = (state) => ({
  promotions: state.promotions.promotions,
  productList: state.promotions.productList,
  groupList: state.promotions.groupList,
  fetched: state.promotions.fetched,
  fetching: state.promotions.fetching
});

const initialState = {
  displayFromDate: '',
  displayToDate: '',
  product: '',
  group: ''
};

export default connect(mapStateToProps)(withInputChange(initialState)(Promotions));



// WEBPACK FOOTER //
// ./src/components/admin/promotions/promotions/list/index.jsx